import { PagedResult } from '../../../shared/model/paged-result.model';
import { AttendeeMin } from './attendee-min.model';

export class AttendeeSearchResult extends PagedResult {
  public Result: Array<AttendeeMin>;
  public AttendeesWithoutProfileCount: number = 0;

  public constructor() {
    super();

    this.Result = new Array<AttendeeMin>();
  }
}
